// See Documentation: ../../../Document/QueueInsights/hooks/use-queue-data.md
import { useState, useEffect, useMemo } from "react";
import useDataAPI from "./useDataAPI";
import { QueueSQLData } from "../../types/queueTypes";
import { normalizeQueueData } from "../../utils/queue-iso-utils";

const useQueueData = (database: string) => {
    const [queueData, setQueueData] = useState<QueueSQLData[]>([]);

    const select = useMemo(() => [
        'County',
        'State',
        'Fuel_Type',
        'Queue_Cycle',
        'ISO',
        'Size_MW',
        'Zone',
        'Study_Phase',
        'Latitude',
        'Longitude',
        'Project_Name',
    ], []);
    
    const filter = useMemo(() => [
        {
            field: 'Queue_Status',
            value: 'Active'
        }
    ], []);

    const { entityItems, loading: dataLoading } = useDataAPI({ 
        entityName: database, 
        first: 10000,
        select: select,
        filter: filter
    });

    useEffect(() => {
        if (!entityItems) return;
        
        // Normalize fuel types to standardized fuel types before setting data
        const rawData = entityItems as QueueSQLData[];
        const normalizedData = normalizeQueueData(rawData);
        setQueueData(normalizedData);
    }, [entityItems]);

    return {
        queueData,
        loading: dataLoading
    };
};

export default useQueueData;
